import React, {useState, useEffect}  from 'react' 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import Tooltip from '@material-ui/core/Tooltip';

import ProgressBar from '../../../components/ProgressBar';
import styles from './styles.module.scss'

import premiumItem from '../../../assets/img/premiumItem.svg';
import goldItem from '../../../assets/img/goldItem.svg';
import plusItem from '../../../assets/img/plusItem.svg';
import brassItem from '../../../assets/img/brassItem.png';
import noneItem from '../../../assets/img/noneItem.png';

import Voltar from '../../../components/VoltarBtn/voltar'

import { getDetalhesDesempenho } from '../../../services/api-auto.js'
import {useParams} from "react-router-dom";

const Detalhes = ({props}) => {

    const{ id } = useParams();
    const [dados, setDados] = useState(null)

    useEffect(()=>{
        getDados()
    },[])

    const getDados = async () => {
        const info = await getDetalhesDesempenho( id );
        setDados(info)
    }

    const mensagem = dados?.proximaClassificacao ? `Faltam <b>${ dados.pontosFaltantes} pontos</b> para atingir a categoria ${dados.proximaClassificacao}` : 
                    `Parabéns, você está na última categoria`;

    const badges = {
        "Sem Classificação": noneItem,
        "Compensa": brassItem,
        "Compensa Plus": plusItem,
        "Compensa Gold": goldItem,
        "Compensa Premium": premiumItem
    }

    const max = {
        Share: 300,
        SPF: 150,
        AP: 100,
        AUTO: 100
    }

    const AutoTooltip = 'teste'
    const marketShareTooltip = ' teste 2'
    const PremistaTooltip = 'teste 3'
    const AcidentesTooltip = ' teste 4'

    
    return(
        <div className={`${styles.wrapper}`}>
            
            <div className={styles.title}>
                Desempenho
                <Voltar />
            </div>

            {
                !Boolean(dados) ? (
                    <div></div>
                ) : (
                    <>
                        <div className={`${styles.actions}`}>
                            <div className={`${styles.card}`}>
                                <div className={`${styles.subTitle}`}>
                                    {dados.nomeParceiro}
                                </div>
                                <div className={styles.firstInfo}>
                                    <div className={styles.infoWrapper}>
                                        <div className={styles.infoLabel}>
                                            Periodo:
                                        </div>
                                        <div className={styles.info}>
                                            {dados.periodo}
                                        </div>
                                    </div>
                                    <div className={styles.infoWrapper}>
                                        <div className={styles.infoLabel}>
                                            Campanha:
                                        </div>
                                        <div className={styles.info}>
                                            {dados.nomeCampanha}
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.innerCard}>
                                    <div className={styles.top}>
                                        <div className={styles.label}>
                                            Categoria atual:
                                        </div>
                                        <div className={styles.categoria}>
                                            <div> {dados?.tipoParceiro?.toUpperCase()} </div>
                                            <img src={badges[dados.classificacao]}/>
                                            <div> {dados.classificacao?.toUpperCase()} </div>
                                        </div>
                                    </div>
                                    <div className={styles.bottom}>
                                        <div className={styles.pontos}>
                                            <div className={styles.label}>
                                                Saldo de pontos:
                                            </div>
                                            <div className={styles.pontos}>
                                                { dados.totalPontos }
                                            </div>
                                        </div>
                                        <div>
                                            <ProgressBar value={dados.totalPontos} maxValue={dados.totalPontos + dados.pontosFaltantes} />
                                        </div>
                                        <div className={styles.icons}>
                                            <img src={badges[dados.classificacao]}/>
                                            <img src={badges[dados.proximaClassificacao]}/>
                                        </div>
                                        <div className={styles.message} dangerouslySetInnerHTML={{ __html: mensagem }} />
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div className={`${styles.logs}`}>
                            <div className={`${styles.subTitle}`}>
                                Resultados no período
                            </div>
                            <div className={styles.secondCard}>
                                <div className={styles.line}>
                                    <div className={styles.label}>
                                        Período
                                    </div>
                                    <div className={styles.info}>
                                        {dados.periodo}
                                    </div>
                                </div>
                                <div className={`${styles.line} ${styles.middleLine}`}>
                                    <div className={styles.label}>
                                        Pontos ganhos no período
                                    </div>
                                    <div className={styles.info}>
                                        {dados.totalPontos}
                                    </div>
                                </div>
                                <div className={styles.line}>
                                    <div className={styles.label}>
                                        Categoria
                                    </div>
                                    <div className={styles.info}>
                                        {dados.classificacao}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.thirdCard}>
                                <div className={styles.titleCard}>
                                    Resultados no período
                                </div>
                                <div className={styles.infoWrapper}>
                                    <div className={styles.infoLabel}>
                                        Market Share
                                        <FontAwesomeIcon title={dados.textoMarketShare} type='fas' icon={faInfoCircle} className={styles.tooltype}/>  
                                    </div>
                                    <div className={styles.bar}>
                                        <ProgressBar value={dados.marketShare} maxValue={max.Share}/>
                                    </div>
                                    <div className={styles.info}>
                                        {dados.marketShare}
                                    </div>
                                </div>
                                <div className={styles.infoWrapper}>
                                    <div className={styles.infoLabel}>
                                        Seguro Premista
                                        <FontAwesomeIcon title={dados.textoSPF} type='fas' icon={faInfoCircle} className={styles.tooltype}/>  
                                    </div>
                                    <div className={styles.bar}>
                                        <ProgressBar value={dados.pontosSPF} maxValue={max.SPF}/>
                                    </div>
                                    <div className={styles.info}>
                                        {dados.pontosSPF}
                                    </div>
                                </div>
                                <div className={styles.infoWrapper}>
                                    <div className={styles.infoLabel}>
                                        Acidentes pessoais
                                        <FontAwesomeIcon title={dados.textoAP} type='fas' icon={faInfoCircle} className={styles.tooltype}/>  
                                    </div>
                                    <div className={styles.bar}>
                                        <ProgressBar value={dados.pontosAP} maxValue={max.AP}/>
                                    </div>
                                    <div className={styles.info}>
                                        {dados.pontosAP}
                                    </div>
                                </div>
                                <div className={styles.infoWrapper}>
                                    <div className={styles.infoLabel}>
                                        Linha auto
                                        <FontAwesomeIcon title={dados.textoLinhaAuto} type='fas' icon={faInfoCircle} className={styles.tooltype}/>  
                                    </div>
                                    <div className={styles.bar}>
                                        <ProgressBar value={dados.pontosLinhaAuto} maxValue={max.AUTO}/>
                                    </div>
                                    <div className={styles.info}>
                                        {dados.pontosLinhaAuto}
                                    </div>
                                </div>
                                <div className={styles.titleCard}>
                                    Qualidade de vendas
                                </div>
                                <div className={styles.infoWrapper}>
                                    <div className={styles.infoLabel}>
                                        Inadimplência
                                    </div>
                                    <div className={styles.info}>
                                        {dados.inadimplencia}
                                    </div>
                                </div>
                                <div className={styles.infoWrapper}>
                                    <div className={styles.infoLabel}>
                                        Cancelamentos
                                    </div>
                                    <div className={styles.info}>
                                        {dados.camcelamentos}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </>
                )
            }
            
        </div>
    )
}

export default Detalhes